import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=4613c865&scoped=true&"
import script from "./Projects.vue?vue&type=script&lang=js&"
export * from "./Projects.vue?vue&type=script&lang=js&"
import style0 from "./Projects.vue?vue&type=style&index=0&id=4613c865&scoped=true&lang=css&"
import style1 from "./Projects.vue?vue&type=style&index=1&id=4613c865&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4613c865",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4613c865')) {
      api.createRecord('4613c865', component.options)
    } else {
      api.reload('4613c865', component.options)
    }
    module.hot.accept("./Projects.vue?vue&type=template&id=4613c865&scoped=true&", function () {
      api.rerender('4613c865', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projects/Projects.vue"
export default component.exports